import { Component, ViewChild } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/angular2-signaturepad';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonapiService } from '../shared/services/commonapi.service';
import { NgxCroppedEvent, NgxPhotoEditorService } from 'ngx-photo-editor';
import * as CryptoJS from 'crypto-js';
import { LivetrainingService } from '../shared/services/livetraining.service';
import { environment } from 'src/environments/environment';
import { ImageCroppedEvent, LoadedImage, base64ToFile } from 'ngx-image-cropper';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
//jquery declaration
declare var $: any;

@Component({
  selector: 'app-trainingentry',
  templateUrl: './trainingentry.component.html',
  styleUrls: ['./trainingentry.component.css']
})
export class TrainingentryComponent {
  name: string = "";
  company: string = "";
  email: string = "";
  url: any; //Angular 11, for stricter type
  course:string='';
  msg = "";
  trainingtrackerId = 0;
  sign = "";
  encPassword: string = '';
  imageChangedEvent: any;
  eventDetails: any = [];
  //base64: any;
  userimage: any = "";
  OpenWebCam: boolean = false;
  isImageLoad: boolean = false;
  //imageChangedEvent: any = '';
  croppedImage: any = '';
  imageBase64String: any;
  IsImageUploadForCrop: boolean = false;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
  };
  public errors: WebcamInitError[] = [];
  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<
    boolean | string
  >();

  @ViewChild('signatureCanvas', { static: true }) signaturePad: SignaturePad;

  signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 5,
    'canvasWidth': 500,
    'canvasHeight': 150
  };

  constructor(
    public router: Router,
    private commonApiService: CommonapiService,
    private activeRoute: ActivatedRoute,
    private service: LivetrainingService,
    private photoservice: NgxPhotoEditorService
  ) {
    this.topposition();

  }

  async ngOnInit() {
    await this.activeRoute.params.subscribe(async routeParams => {
      this.trainingtrackerId = CryptoJS.AES.decrypt(routeParams.id.toString(), this.encPassword).toString(CryptoJS.enc.Utf8);
      this.course=routeParams.course.toString();

      await this.service.getEvents().then(Data => {
        this.eventDetails = Data.filter(x => x.id == this.trainingtrackerId)[0];
        console.log("details",this.eventDetails);
      })
    });
  }

  ngAfterViewInit() {
    // this.signaturePad is now available
    this.signaturePad.set('minWidth', 2);
    this.signaturePad.clear();
    this.sign = "";
  }

  drawComplete() {
    
  }

  drawStart() {
    console.log('begin drawing');
  }

  fileChangeEvent(event: any) {
    this.imageChangedEvent = event;
  }

  fileChangeHandler($event: any) {
    this.photoservice.open($event, {
      aspectRatio: 4 / 3,
      autoCropArea: 1
    }).subscribe(data => {
      this.url = data;
    });
  }

  // imageCropped(event: NgxCroppedEvent) {
  //   this.url = event.base64;
  // }

  showsignaturepopup() {
    $('#signatureModal').modal('show');
  }

  clearSignature() {
    this.signaturePad.clear();
    this.sign = "";
  }

  backToLiveEvents() {
    this.router.navigate(["/livetrainings"]);
  }

  //selectFile(event) { //Angular 8
  selectFile(event: any) { //Angular 11, for stricter type

    console.log("called");
    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg = "Only images are supported";
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);

    reader.onload = (_event) => {
      this.msg = "";
      this.url = reader.result;
    }
  }

  async submitData() {

    if (this.name === "") {
      alert("Please Enter Your Name");
      document.getElementById("name").focus();
      return;
    }
    else if (this.company === "") {
      alert("Please Enter Your Company");
      document.getElementById("company").focus();
      return;
    }    
    else if (this.email !== "" && this.ValidateEmail(this.email) === false) {
      alert("Please Enter Valid Email Address");
      document.getElementById("email").focus();
      return;
    }
    else if(this.eventDetails.IsPicturesForCard==true && (this.userimage === undefined || this.userimage === ""))    
    {
      alert("Please upload a selfie. (Picture for your card)");      
      return;
    }
    else if(this.sign==="" || this.sign ===undefined)    
    {
      alert("Please add signature");      
      return;
    }

    console.log("usrl is " + this.url);

    const _obj = {
      Mode: "ADD",
      TrainingTrackerRosterID: 0,
      TrainingTrackerID: this.trainingtrackerId,
      StudentName: this.name.toString(),
      StudentCompanyName: this.company.toString(),
      StudentEmailID: this.email.toString(),
      // StudentImage: this.url === undefined ? "" : this.url,
      StudentImage:this.userimage,
      StudentSign: this.sign,
      ClearImage: 0,
      UserID: 1,
    };

    let _dt = await this.commonApiService.postData("api/TrainingApi/DBTrainingTrackerRosterCrudOperation/", _obj).toPromise();

    console.log(_dt);


    if (_dt && _dt[0].dataSet && _dt[0].dataSet.message) {
      $('#exampleModal').modal('hide');
      alert(_dt[0].dataSet.message);
      if (_dt[0].dataSet.message !== "") {
        this.name = "";
        this.company = "";
        this.email = "";
        this.url = "";
        this.sign = "";
        this.trainingtrackerId = 0;
        let _link=environment.api+"/PDFUploads/TrainingCoursePDF/" + this.eventDetails.CoursePDF;
        console.log(_link);
        window.open(_link, "_blank");
        this.backToLiveEvents();

      }
    }


  }

  showpopup() {

    console.log(this.sign);
    if (this.name === "") {
      alert("Please Enter Your Name");
      document.getElementById("name").focus();
      return;
    }
    else if (this.company === "") {
      alert("Please Enter Your Company");
      document.getElementById("company").focus();
      return;
    }
    else if (this.email !== "" && this.ValidateEmail(this.email) === false) {
      alert("Please Enter Valid Email Address");
      document.getElementById("email").focus();
      return;
    }
    else if(this.eventDetails.IsPicturesForCard==true && (this.userimage === undefined || this.userimage === ""))    
    {
      alert("Please upload a selfie. (Picture for your card)");      
      return;
    }
    else if(this.sign==="" || this.sign ===undefined)    
    {
      alert("Please add signature");      
      return;
    }
    else if(this.email==="" || this.email ===undefined)    
    {
      alert("Warning: Your e-mail address is used to link this training/meeting documents to your  account as well as to send digital copies directly to you, the attendee. By choosing to proceed without an e-mail, you agree to forfeit these features. Are you sure you wish to proceed?");      
      
    }
    $('#exampleModal').modal('show');


  }


  ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return (true)
    }
    return (false)
  }

  createSign(){
    this.sign = this.signaturePad.toDataURL();
  }


  topposition() {
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
  }
  // Selfie code 
  async imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
   
  }
  CropImage() {
    
    let circleCanvas = document.createElement('canvas');
    var img1 = document.createElement('img');
    img1.src = this.croppedImage;
    setTimeout(() => {
      var canvaswidth = img1.naturalWidth;
      var canvasheight = img1.naturalHeight;
      circleCanvas.width = canvaswidth;
      circleCanvas.height = canvasheight;

      let circleCtx = circleCanvas.getContext('2d');

      // draw image with circle shape clip

      circleCtx.save();
      circleCtx.beginPath();
      circleCtx.lineWidth = 8;
      circleCtx.arc(125, 125, 120, 0, Math.PI * 2, false);
      circleCtx.strokeStyle = '#ddd';
      circleCtx.stroke();
      circleCtx.clip();
      circleCtx.drawImage(img1, 0, 0, img1.width, img1.height);
      circleCtx.restore();
      this.userimage = circleCanvas.toDataURL('image/png', 1);

    },500)
    
    this.IsImageUploadForCrop = false;
    
    /*$("#CropImageModal").modal("hide");*/
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }
  removeRosterImage() {
    this.userimage = "";
   // this.imageBase64String = "";
    //this.IsImageUploadForCrop = false;
    //$('#imgRosterFile').val('');
  }
  CropImageCLose() {
    this.IsImageUploadForCrop = false;
    this.croppedImage = "";
    this.imageBase64String = "";
  }
  async Takeselfie() {
    this.userimage = "";
    this.OpenWebCam = true;
    this.isImageLoad = true;
  }
  checkPermissions() {
    navigator.mediaDevices.getUserMedia({
      video: {
        //width: 500,
        //height: 500
      }
    }).then((res) => {
      console.log("response", res);
     
    }).catch(err => {
      console.log(err.message);
      if (err?.message === 'Permission denied') {
        alert("Permission denied please try again by approving the access");   
        //this._commonservice.ShowAlert("Permission denied please try again by approving the access", AlertType.Warning, null);
      } else {
        alert("You may not having camera system, Please try again ...");   
        //this._commonservice.ShowAlert("You may not having camera system, Please try again ...", AlertType.Error, null);
      //  this._commonservice.ShowAlert(err.message, AlertType.Error, null);
      }
    })
  }
  removeCaptureImage() {
    this.OpenWebCam = false;
    this.isImageLoad = false;
    this.userimage = "";
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
    console.log(error);
    if (error.message == "Permission denied") {
      alert("Permission denied please try again by approving the access");   
      this.isImageLoad = false;
      this.OpenWebCam = false;
    }
    else {

     // this.commonApiService.ShowAlert(error.message, AlertType.Error, null);
      this.isImageLoad = false;
      this.OpenWebCam = false;
    }

  }
  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    debugger
    console.info('received webcam image', webcamImage);
    let circleCanvas = document.createElement('canvas');
    var img1 = document.createElement('img');
    img1.src = webcamImage.imageAsDataUrl;
    
    setTimeout(() => {
      var canvaswidth = img1.naturalWidth;
      var canvasheight = img1.naturalHeight;
      
      circleCanvas.width = canvaswidth;
      circleCanvas.height = canvasheight;

      let context = circleCanvas.getContext('2d');

      // draw image with circle shape clip
      let x = canvaswidth / 2;
      let y = canvasheight / 2;
      
      context.translate(img1.width, 0);
      context.scale(-1, 1);

      context.strokeStyle = "#ddd";
      context.lineWidth = 12;
      context.beginPath();
      context.arc(x, y, 235, 0, 360,false);
      context.closePath();
      context.stroke();
      context.clip();
      context.drawImage(img1, 0, 0, canvaswidth, canvasheight);
      context.restore();
      this.userimage = circleCanvas.toDataURL('image/png', 1);
      this.OpenWebCam = false;
      
     
    }, 500);
  }
  

  public cameraWasSwitched(deviceId: string): void {
    console.log('active device: ' + deviceId);
     this.deviceId = deviceId;
    this.isImageLoad = false;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }
  // End Selfie code


}
